import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-funfacts-style-five',
  templateUrl: './funfacts-style-five.component.html',
  styleUrls: ['./funfacts-style-five.component.scss']
})
export class FunfactsStyleFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
